<template>
  <div id="pageRoot">
    <div id="bg">
      <img src="/pages/img/sordocas/svgCas32bg.svg" />
      <p class="textBaseCourier" id="text01">ENCICLOPEDIA</p>
      <p class="textBaseCourier" id="text02">
        LOS CASTILLOS ¿EXISTEN FUERA DE LOS CUENTOS?
      </p>
      <p class="textBaseCourier textSimple" id="text03">
        Hace muchos años, en una región del mundo llamada Europa, se
        construyeron grandes rsidencias a las que se llamó castillos. Los
        castillos daban vivienda a las personas mas poderosas de la región y
        servían como fortalezas militares.
      </p>
      <p class="textBaseCourier textSimple" id="text05">
        Los castillos solían ser de piedra. Se construían en lo alto de una
        colina y estaban rodeados por una alta y gruesa muralla.
      </p>
    </div>
  </div>
</template>
<style scoped>

.textSimple {
  font-size: 22px;
  line-height: 33px;
  color: #000000;
}

#text01 {
  position: absolute;
  width: 402px;
  height: 78px;
  left: 315px;
  top: 103px;
  font-size: 51px;
  line-height: 55px;
  text-align: center;
  letter-spacing: 0.015em;
  color: #231f20;
}
#text02 {
  position: absolute;
  width: 791px;
  height: 104px;
  left: 84px;
  top: 184px;
  font-weight: bold;
  font-size: 47px;
  line-height: 53px;
  color: #231f20;
}
#text03 {
  position: absolute;
  width: 403px;
  left: 84px;
  top: 300px;
}
#text05 {
  position: absolute;
  width: 850px;
  height: 198px;
  left: 84px;
  top: 620px;
}

#bg {
  position: absolute;
  left: 31px;
  top: 41px;
  z-index: 3;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 41px;
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "cas/Video 127.mp4",
        "cas/Video 128a.mp4",
        "cas/Video 128b.mp4",
        "cas/Video 129.mp4",
      ],
    };
  },
};
</script>